import { IStyle } from '@fluentui/react';
import { defaultPalette, FontWeights, IH2OTheme } from '@h2oai/ui-kit';

export interface AuditTrailListClassNames {
  root: string;
  list: string;
  listHeader: string;
  column: string;
}

export interface AuditTrailListStyles {
  root: IStyle;
  list: IStyle;
  listHeader: IStyle;
  column: IStyle;
}

export const auditTrailListStylesDefault = (theme: IH2OTheme): Partial<AuditTrailListStyles> => ({
  root: {
    height: '100%',
    fontFamily: 'monospace',
    color: theme.palette?.gray300,
    backgroundColor: theme.palette?.gray900,
    paddingLeft: 50,
    padding: '20px 0 20px 30px',
    overflow: 'auto',
    table: { tableLayout: 'fixed' },
  },
  listHeader: {
    fontWeight: FontWeights.fw700,
    fontFamily: theme.defaultFontStyle?.fontFamily,
    color: theme.palette?.white,
    padding: `5px 10px 10px 10px`,
  },
  list: {
    flex: 1,
    overflow: 'auto',
    fontFamily: 'monospace',
  },
});

export interface AuditTrailListRowClassNames {
  root: string;
  collapsed: string;
  expanded: string;
  expandedFullText: string;
  header: string;
  logText: string;
  expandable: string;
  logLine: string;
  truncate: string;
}

export interface AuditTrailListRowStyles {
  root: IStyle;
  collapsed: IStyle;
  expanded: IStyle;
  expandedFullText: IStyle;
  header: IStyle;
  logText: IStyle;
  expandable: IStyle;
  logLine: IStyle;
  truncate: IStyle;
}

export const auditTrailListRowStyles = (
  theme: IH2OTheme,
  expanded: boolean,
  isHeader?: boolean
): Partial<AuditTrailListRowStyles> => ({
  root: {
    fontFamily: 'inherit',
    padding: '2px 10px',
    color: isHeader || expanded ? defaultPalette.white : 'inherit',
    ...(isHeader
      ? {
          fontFamily: theme.defaultFontStyle?.fontFamily,
          padding: '5px 10px 10px 10px',
          textTransform: 'capitalize',
        }
      : {}),
    td: { paddingBottom: expanded ? 8 : 0 },
    span: {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    },
  },
  logText: {
    fontFamily: 'inherit',
    padding: '2px 10px',
    color: 'inherit',
  },
  expandable: {
    paddingBottom: 20,
    paddingLeft: 97,
    paddingTop: 8,
  },
  logLine: {
    maxWidth: '100%',
    color: expanded ? defaultPalette.white : 'inherit',
    paddingLeft: 20,
  },
  expandedFullText: { lineHeight: '1.2' },
  collapsed: { height: 21 },
  header: { fontWeight: FontWeights.fw700 } as IStyle,
});
